import LinkTableBatchModifyDialog from './link-table-batch-modify-dialog'

class BatchModifyService {

    $lv;

    _ins;

    get instance() {
        if (!this._ins) this._ins = this.newInstance()
        return this._ins;
    }

    constructor($lv) {
        this.$lv = $lv
    }

    newInstance() {
        return this.$lv.newInstance(LinkTableBatchModifyDialog)
    }

    show({columns, onConfirm, onCancel, dialogProps}) {
        this.instance.show({columns, onConfirm, onCancel, dialogProps});
    }

}

export {BatchModifyService}
